import EntityStatus from "./EntityStatus";
import { Link } from "react-router-dom";
import GenericTable, { GenericTableColumn } from "./GenericTable";
import { ClientCompany } from "../types/clientCompanies";

type ClientCompaniesTableProps = {
  companies: ClientCompany[];
  canManageClientCompanies: boolean;
};

function ClientCompaniesTable({
  companies,
  canManageClientCompanies,
}: ClientCompaniesTableProps) {
  const columns: GenericTableColumn<ClientCompany>[] = [
    {
      id: "name",
      header: "Name",
      cell: (company) => (
        <>
          {company.name} <EntityStatus deletedAt={company.deletedAt} />
        </>
      ),
    },
    {
      id: "registrationNumber",
      header: "Registration Number",
      cell: (company) => company.registrationNumber,
    },
    {
      id: "contactEmail",
      header: "Contact Email",
      cell: (company) => company.contactEmail ?? "-",
    },
    {
      id: "actions",
      header: "Actions",
      headerClassName: "actionsColumn",
      cellClassName: "actionsColumn",
      cell: (company) =>
        canManageClientCompanies ? (
          <Link
            className="secondaryButton tableActionButton"
            to={`/client-companies/${company.id}/edit`}
          >
            Edit
          </Link>
        ) : (
          <span className="secondaryButton tableActionButton disabledAction">
            Edit
          </span>
        ),
    },
  ];

  return (
    <GenericTable
      ariaLabel="Client companies"
      columns={columns}
      rows={companies}
      rowKey={(company) => company.id}
    />
  );
}

export default ClientCompaniesTable;
